export const simplifyPartName = (title) => (/^\d*:\ /gm.test(title) ? title.split(/:\ {1}/gm)[1] : title);
